module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Unidade",
      "value": _vm.extensaoe.unidade ? (_vm.extensaoe.unidade.nome + (_vm.extensaoe.unidade.siglaUnidade == null ? '' : ' - ' + _vm.extensao.unidade.siglaUnidade)) : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Órgão competente pela aprovação",
      "value": _vm.extensaoe.orgaoCompetente ? _vm.extensaoe.orgaoCompetente : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Coordenado por",
      "value": _vm.extensaoe.coordenadoPor ? _vm.extensaoe.coordenadoPor.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data da primeira apresentação",
      "value": _vm.extensaoe.dtPrimeiraApresentacao ? _vm.dates.format(_vm.extensaoe.dtPrimeiraApresentacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data da última revisão",
      "value": _vm.extensaoe.dtRevisao ? _vm.dates.format(_vm.extensaoe.dtRevisao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.situacao.item === 17) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de inabilitação pela Câmara de Extensão",
      "value": _vm.extensaoe.dtInabilitacao ? _vm.dates.format(_vm.extensaoe.dtInabilitacao) || '-' : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de Evento",
      "value": _vm.extensaoe.tipoEvento ? _vm.extensaoe.tipoEvento.descricao : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "O programa é uma Empresa Júnior?",
      "value": _vm.extensaoe.empresaJunior != null ? (_vm.extensaoe.empresaJunior ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Apresentação",
      "value": this.extensaoe.apresentacao || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Justificativa / Mérito extensionista",
      "value": this.extensaoe.justificativa || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Caracterização do público-alvo",
      "value": this.extensaoe.caracterizacaoPublicoAlvo || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    staticClass: "publicoAlvo",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Caracterização do público-alvo")])])], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo && _vm.projeto.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "• Interno:",
      "value": this.extensaoe.publicoAlvoInterno || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "• Externo:",
      "value": this.extensaoe.publicoAlvoExterno || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Objetivo geral",
      "value": this.extensaoe.objetivosGerais || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelObjetivosEspecificos"
  }, [_vm._v("Objetivos específicos")]), _vm._v(" "), _c('v-list', {
    staticClass: "listObjetivosEspecificos"
  }, _vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('v-list-item', {
      key: item.id,
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('v-list-item-content', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("\n                " + _vm._s(index + 1) + ". " + _vm._s(item.nome) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "mt-3"
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Metodologia",
      "value": this.extensaoe.metodologia || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('c-readonly-field', {
    attrs: {
      "label": "Formas de avaliação dos cursistas",
      "value": this.extensaoe.formaAvaliacao || '-',
      "align": "justify"
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Forma de avaliação",
      "value": this.extensaoe.formaAvaliacao || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Infraestrutura física",
      "value": this.extensaoe.infraestruturaFisica || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Informações adicionais",
      "value": this.extensaoe.informacoesAdicionais || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de Prestação de Serviço",
      "value": '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "multiple": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "font-size": "1.2em"
          }
        }, [_vm._v("Tipo de Prestação de Serviço")])]
      },
      proxy: true
    }], null, false, 4110279761),
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus Culturais",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Cines-clube",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Outros",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAssessorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAssessorias", $$v)
      },
      expression: "this.extensaoe.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultorias", $$v)
      },
      expression: "this.extensaoe.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCuradorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCuradorias", $$v)
      },
      expression: "this.extensaoe.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numOutrosServicos", $$v)
      },
      expression: "this.extensaoe.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numPatentesModelos", $$v)
      },
      expression: "this.extensaoe.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numMarcasSoftwares", $$v)
      },
      expression: "this.extensaoe.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numTransferenciaTecnologia", $$v)
      },
      expression: "this.extensaoe.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numDireitosAutorais", $$v)
      },
      expression: "this.extensaoe.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numLaudosEmitidos", $$v)
      },
      expression: "this.extensaoe.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAtendimentosJuridicos", $$v)
      },
      expression: "this.extensaoe.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultasAmbulatoriais", $$v)
      },
      expression: "this.extensaoe.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultasEmergencia", $$v)
      },
      expression: "this.extensaoe.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numInternacoes),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numInternacoes", $$v)
      },
      expression: "this.extensaoe.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCirurgias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCirurgias", $$v)
      },
      expression: "this.extensaoe.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesLaboratoriais", $$v)
      },
      expression: "this.extensaoe.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesComplementares", $$v)
      },
      expression: "this.extensaoe.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numOutrosAtendimentosSH", $$v)
      },
      expression: "this.extensaoe.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAtendimentosVeterinarios", $$v)
      },
      expression: "this.extensaoe.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numInternacoesVeterinarias", $$v)
      },
      expression: "this.extensaoe.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCirurgiasVeterinarias", $$v)
      },
      expression: "this.extensaoe.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesVeterinaria", $$v)
      },
      expression: "this.extensaoe.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('p', {
    staticClass: "mt-3"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com ensino",
      "value": _vm.extensaoe.vinculoEnsino != null ? (_vm.extensaoe.vinculoEnsino ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "value": _vm.extensaoe.vinculoPesquisa != null ? (_vm.extensaoe.vinculoPesquisa ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "value": _vm.extensaoe.divulgacaoCientifica != null ? (_vm.extensaoe.divulgacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)",
      "value": _vm.extensaoe.direcionadaEscolaPublica != null ? (_vm.extensaoe.direcionadaEscolaPublica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES",
      "value": _vm.extensaoe.creditacaoGraduacao != null ? (_vm.extensaoe.creditacaoGraduacao ? 'Sim' : 'Não') : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data inicial da creditação",
      "value": _vm.extensaoe.dtInicialCreditacao ? _vm.dates.format(_vm.extensaoe.dtInicialCreditacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "value": _vm.extensaoe.captacaoRecursosBensDuraveis != null ? (_vm.extensaoe.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Por meio de:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "extensao.captacaoRecursosFapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.extensao.captacaoRecursosFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFucam", $$v)
      },
      expression: "extensao.captacaoRecursosFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "extensao.especCaptacaoRecursosOutros"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "value": _vm.extensaoe.liberacaoCargaHoraria != null ? (_vm.extensaoe.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensaoe.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária aprovada",
      "value": this.extensaoe.cargaHorariaCoordenadorAprovada || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina || _vm.extensaoe.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Gratuito para o público",
      "value": _vm.extensaoe.gratuito != null ? (_vm.extensaoe.gratuito ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoUfes", $$v)
      },
      expression: "extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFest", $$v)
      },
      expression: "extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFucam", $$v)
      },
      expression: "extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoOutros", $$v)
      },
      expression: "extensao.gratuitoOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [(_vm.extensao.gratuito === false) ? _c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especGratuitoOutros", $$v)
      },
      expression: "extensao.especGratuitoOutros"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Modalidade",
      "value": _vm.extensaoe.modalidade != null ? (_vm.extensaoe.modalidade == 'P' ? 'Presencial' : (_vm.extensaoe.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "value": _vm.extensaoe.utilizaAvaExtensao != null ? (_vm.extensaoe.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Outra plataforma AVA",
      "value": _vm.extensaoe.plataforma || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Suspensões")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Suspensões",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Registro de relatórios enviados")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersRegistroRelatoriosEnviados,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaRegistroRelatoriosEnviados,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtEnvio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtEnvio)))]
      }
    }], null, false, 1802811833)
  }) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Registro de relatórios enviados",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "IntegrantesProjeto",
      "editar": "EditarExtensao",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3219b534","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-extensao.vue
// module id = 469
// module chunks = 0